import { useAssignedAgentsQuery } from "web_myplann/Api/Advisor/useAssignedAgentsQuery";
import { UserAgentStatusEnum } from "web_myplann/Infrastructure/Api/Api";

export const useConnectedAdvisor = (uid?: string) => {
	const { data } = useAssignedAgentsQuery(UserAgentStatusEnum.Connected);

	return data?.data.find((advisor) => advisor.uid === uid);
};
